import React, { Component, PropTypes } from 'react';
import './exit.scss';

export default class Exit extends Component {

  static contextTypes = {
    setActiveSession: PropTypes.func.isRequired,
    setMode: PropTypes.func.isRequired,
    hideHUD: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  }

  exitSession () {
    const { setActiveSession } = this.context;
    setActiveSession('none');
  }

  returnToPresentation () {
    const { setMode, hideHUD } = this.context;
    setMode(null);
    hideHUD();
  }

  render () {
    const { i18n: _ } = this.context;
    return (
      <div className="exit">
        <h1>{_('Exit Session?')}</h1>
        <div className="button-group">
          <button
              className="btn btn-lg btn-primary btn-wrap"
              onClick={::this.exitSession}>
            {_('Yes, exit to DASHBOARD')}
          </button>
          <button
              className="btn btn-sm btn-default"
              onClick={::this.returnToPresentation}>
            {_('No, back to presentation')}
          </button>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/exit/index.jsx